import { getAuthHeaders, refreshMergedLlmPermissions } from '../../../../services';
import API from '../../../../services/api-middleware';
import { BudgetDetailsProps } from '../pages/budget/budget.props';
import { roleDetailsProps } from '../pages/roles/roles.props';
import { tableFunctionsProps, userDetailsProps } from '../pages/users/user.props';

const baseUrl = process.env.REACT_APP_USER_SERVER_URL;
const baseLLMUrl = process.env.REACT_APP_LLM_SERVER_URL;
// get users list
export const getUsers = async (payload: tableFunctionsProps) => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const encodedFilters = encodeURIComponent(JSON.stringify(payload.filters));
    const encodedSearchValue = encodeURIComponent(payload.search);
    const response = await API(baseLLMUrl).get(
      `user-queries?limit=${payload.limit}&offset=${payload.offset}&search=${encodedSearchValue}&sort_col=${payload.sort_col}&sort_order=${payload.sort_order}&filters=${encodedFilters}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// get roles list
export const getUserRoles = async (payload: tableFunctionsProps) => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).get(
      `roles?limit=${payload.limit}&offset=${payload.offset}&search=${payload.search}&sort_col=${payload.sort_col}&sort_order=${payload.sort_order}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getRoles = async () => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).get(`roles?all=true`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getPermissionData = async () => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).get(`permissions`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// get roles Permissions
export const getAccounts = async () => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).get(`accounts`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// get roles Permissions
export const getPermissions = async () => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).get(`permissions?format=hierarchical`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// create new role
export const createRole = async (payload: roleDetailsProps) => {
  const data = { ...payload, permissions: payload.permissions.toString() };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).post(`roles`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const createBudget = async (payload: BudgetDetailsProps) => {
  const data = {
    ...payload,
    user_id: 1,
    name: 'grazitti',
    gateway_id: 1,
  };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).put(`accounts/budget`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const createUser = async (payload: userDetailsProps) => {
  const data = { ...payload };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).post(`users`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// edit existing role
export const editUser = async (payload: userDetailsProps, userId: number) => {
  const data = {
    ...payload,
    user_id: userId,
  };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).patch(`users`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// edit existing role
export const editRole = async (payload: roleDetailsProps, id: number) => {
  const data = {
    ...payload,
    permissions: payload.permissions.toString(),
    role_id: id,
  };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).put(`roles`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// delete role
export const deleteRole = async (id: Array<number>) => {
  const data = {
    role_id: id,
  };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).delete(`roles`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const createTeam = async (payload: { name: string }) => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).post(`teams`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateTeam = async (payload: { name: string }, teamId: number) => {
  const data = {
    ...payload,
    team_id: teamId,
  };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).put(`teams`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteTeams = async (ids: Array<number>) => {
  const data = {
    team_ids: ids,
  };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).delete(`teams`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// delete user
export const deleteUser = async (id: Array<number>) => {
  const data = {
    user_id: id,
  };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).delete(`users`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

/** Response shape from user/configuration API used by getUserConfigurations and SSO flows */
export type UserConfigResponse = {
  status?: number;
  data?: {
    data?: {
      is_super_admin?: boolean;
      permission?: Array<{ module: string; data: string[]; id: number | null }>;
      configuration?: {
        input_tokens_consumed?: number;
        output_tokens_consumed?: number;
        tokens_alloted?: number;
      };
    };
  };
};

/**
 * Persist user config from a user/configuration API response (permissions, is_super_admin, configurations).
 * Call this after SSO completes or whenever config is fetched.
 */
export const applyUserConfigFromResponse = (res: UserConfigResponse): void => {
  const isSuperAdmin: boolean = res?.data?.data?.is_super_admin ?? false;
  const allPermissions = res?.data?.data?.permission ?? [];
  if (isSuperAdmin) {
    allPermissions.push({
      module: 'system-admin',
      data: ['create', 'update', 'view', 'delete'],
      id: null,
    });
    localStorage.setItem('is_super_admin', JSON.stringify(isSuperAdmin));
  }
  localStorage.setItem('permissions', JSON.stringify(allPermissions));
  if (res?.data?.data?.configuration) {
    localStorage.setItem('configurations', JSON.stringify(res.data.data.configuration));
    window.dispatchEvent(new CustomEvent('grigo-configuration-updated'));
  }
};

export const getUserConfigurations = async () => {
  const userId = localStorage.getItem('user_id');
  let parsedID;
  if (userId) {
    parsedID = JSON.parse(userId);
  }
  const data = { user_id: parsedID };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).get(`user/configuration?user_id=${data.user_id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Same as login/SSO: refetch `/user/configuration`, persist permissions + configuration (models) to localStorage,
 * then refresh merged LLM list and notify the app so the header banner and model pickers update.
 */
export async function reloadUserConfigurationsAfterLlmChange(): Promise<void> {
  try {
    const res = await getUserConfigurations();
    if (res?.status === 200 && res?.data?.data) {
      applyUserConfigFromResponse(res as UserConfigResponse);
    }
  } catch {
    /* non-fatal: still try to invalidate merged permission cache */
  }
  try {
    await refreshMergedLlmPermissions();
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new CustomEvent('grigo-configuration-updated'));
}

export const getEmbeddedModels = async () => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseLLMUrl).get(`embedding/model?all=true`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

/** Fetch queries for a specific user (User Queries modal). GET /user-queries?user_id= */
export const getQueriesByUserId = async (userId: number) => {
  try {
    const response = await API(baseLLMUrl).get(
      `/query-tracking?filters=[{"type":"user_id","value":["${userId}"]}]`,
      {
        headers: getAuthHeaders(),
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};
